import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Experience from "./components/Experience";
import Services from "./components/Services";
import Packages from "./components/Packages";
import { HowItWorks, WhyChooseUs, SpecialOffer } from "./components/BrochureSections";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

const Home = () => (
  <div className="App bg-[#fbf3e4]">
    <Navbar />
    <Hero />
    <About />
    <Experience />
    <Services />
    <HowItWorks />
    <WhyChooseUs />
    <Packages />
    <SpecialOffer />
    <Testimonials />
    <Contact />
    <Footer />
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
      </Routes>
      <Toaster />
    </BrowserRouter>
  );
}

export default App;
